import { render } from "./VidhanSabha.vue?vue&type=template&id=e0b76ff6&scoped=true"
import script from "./VidhanSabha.vue?vue&type=script&lang=js"
export * from "./VidhanSabha.vue?vue&type=script&lang=js"

import "./VidhanSabha.vue?vue&type=style&index=0&id=e0b76ff6&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b76ff6"]])

export default __exports__